// extracted by mini-css-extract-plugin
module.exports = {"regular":"Loader_regular__mlbe6","fullScreen":"Loader_fullScreen__fVT1O"};